
// Dev

// const TEST_URL = 'syb-remote.goodthings.io'
// export const WS_URL = `ws://${TEST_URL}/ws`
// export const API_URL = `http://${TEST_URL}`

// Prod
export const WS_URL = `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/ws`
export const API_URL = ''



// WEBPACK FOOTER //
// ./src/Config.js